// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';
import queryString from 'query-string';

import { toast } from 'react-toastify';

export const getProposal = createAsyncThunk('proposalSlice/getProposal', async (data) => {
    const query = queryString.stringify(data);

    try {
        let response = await axios.get('/Quotation?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const getProposalfilter = createAsyncThunk('proposalSlice/getProposalfilter', async (data) => {
    const query = queryString.stringify(data);

    try {
        let response = await axios.get('/Quotation?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const getQuotationNo = createAsyncThunk('proposalSlice/getQuotationNo', async () => {
    try {
        let response = await axios.get('/Quotation/quotation-number', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const getProposalId = createAsyncThunk('proposalSlice/getProposalId', async (id) => {
    try {
        let response = await axios.get('/Quotation/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

// export const getDayAdjustmentStatus = createAsyncThunk('dayAdjustmentSliceData/getDayAdjustmentStatus', async () => {
//     try {
//         let response = await axios.get('/DayAdjustment?status=true', {
//             headers: {
//                 'Content-Type': 'application/json'
//             }
//         });
//         return Promise.resolve(response?.data);
//     } catch (err) {
//         toast.error(err?.response?.data?.message || 'Something went wrong!');
//         console.log('err', err);
//         return Promise.reject(err);
//     }
// });

// export const createDayAdjustment = createAsyncThunk('dayAdjustmentSliceData/createDayAdjustment', async (data, { dispatch }) => {
//     try {
//         let response = await axios.post('/DayAdjustment', data, {
//             headers: {
//                 'Content-Type': 'application/json'
//             }
//         });
//         toast.success(response?.data?.message || 'DayAdjustment added succesfully.');
//         await dispatch(getDayAdjustment());
//         return Promise.resolve(response);
//     } catch (err) {
//         toast.error(err?.response?.data?.message || 'Something went wrong!');
//         console.log('err', err);
//         return Promise.reject(err);
//     }
// });

export const createProposal = createAsyncThunk('proposalSlice/createProposal', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/Quotation', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Proposal added succesfully.');
        // await dispatch(getProposal());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateProposal = createAsyncThunk('proposalSlice/updateProposal', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/Quotation/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Proposal updated succesfully.');
        // await dispatch(getProposal());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updatePO = createAsyncThunk('proposalSlice/updatePO', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/Quotation/update-po/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        toast.success(response?.data?.message || 'PO  updated succesfully.');
        await dispatch(getProposal());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const deleteProposal = createAsyncThunk('proposalSlice/deleteProposal', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/Quotation/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Proposal deleted successfully.');
        await dispatch(getProposal());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateDayAdjustmentStatus = createAsyncThunk('proposalSlice/updateDayAdjustmentStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/DayAdjustment/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status Updated Succesfully');
        await dispatch(getDayAdjustment());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
// send to invoive
export const quotationSendToInvoice = createAsyncThunk('proposalSlice/quotationSendToInvoice', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/Quotation/send-to-invoice/' + data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Send To Invoice succesfully.');
        // await dispatch(getProposal());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const proposalSlice = createSlice({
    name: 'proposalSlice',
    initialState: {
        data: [],
        proposalfilter: [],
        quotationNo: {}
    },
    extraReducers: (builder) => {
        builder.addCase(getProposal.fulfilled, (state, action) => {
            state.data = action?.payload;
            return;
        });
        builder.addCase(getProposalfilter.fulfilled, (state, action) => {
            state.proposalfilter = action?.payload;
            return;
        });
        builder.addCase(getQuotationNo.fulfilled, (state, action) => {
            state.quotationNo = action?.payload;
            return;
        });
    }
});

export default proposalSlice.reducer;
